/* eslint-disable react/prop-types */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { showGlobalLoading, hideGlobalLoading } from '@Lib/slices/uiSlice';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { createBrowserHistory } from 'history';
import { Title, BackButton } from './styles';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: '',
      errorInfo: '',
      hasError: false,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  async componentDidCatch(error, errorInfo) {
    this.props.hide();
    console.log(error.stack);
    // sendMessageToSlack(error.stack);
    this.setState({ errorInfo });
  }

  render() {
    const { name, url } = this.props;
    const { hasError, errorInfo } = this.state;

    const rediretToDashboard = () => {
      document.location = '/dashboard';
    };

    if (hasError) {
      return (
        <div>
          <div className="d-flex justify-content-center pt-2">
            <img src="/images/logo/logo-vcl.svg" width="222" alt="logo" />
          </div>
          <div className="container">
            <div className="content-public-wrapper">
              <div className="d-flex justify-content-center">
                <div>
                  <img src="/images/page/error.svg" width="700" alt="page not found" />
                  <Title>Có lỗi xảy ra.</Title>
                  <div className="w-100 text-center">
                    <BackButton onClick={() => rediretToDashboard()}>Trang chủ</BackButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  name: PropTypes.string,
  url: PropTypes.string,
};

const mapDispatchToProps = (dispatch) => {
  return {
    // dispatching plain actions
    hide: () => dispatch(hideGlobalLoading()),
    show: () => dispatch(showGlobalLoading()),
  };
};

export default connect(null, mapDispatchToProps)(ErrorBoundary);
